import BrandFilter from '@/components/product-filter/brand-filter/brand-filter'
import ClearFilter from '@/components/product-filter/clear-filter/clear-filter'
import ColorFilter from '@/components/product-filter/color-filter/color-filter'
import ModelFilter from '@/components/product-filter/model-filter/model-filter'
import SurfaceFilter from '@/components/product-filter/surface-filter/surface-filter'
import SafetyClassificationFilter from '@/components/product-filter/safety-classification-filter/safety-classification-filter'
import DoorFilter from '@/components/product-filter/door-filter/door-filter'
import WindowFilter from '@/components/product-filter/window-filter/window-filter'
//
import utils from '@/utils/utils'

import {mapState} from 'vuex'
//

const ProductFilter = {
  // Components
  components: {
    'brand-filter': BrandFilter,
    'clear-filter': ClearFilter,
    'color-filter': ColorFilter,
    'model-filter': ModelFilter,
    'surface-filter': SurfaceFilter,
    'safety-classification-filter': SafetyClassificationFilter,
    'door-filter': DoorFilter,
    'window-filter': WindowFilter,
  },
  // Data
  data() {
    return {
      // These are used for query string purposes
      checkedBrands: this.getData('brands'),
      checkedColors: this.getData('colors'),
      checkedModels: this.getData('models'),
      checkedSurfaces: this.getData('surfaces'),
      checkedSafetyClassifications: this.getData('safetyClassifications'),
      checkedDoors: this.getData('doors'),
      checkedWindows: this.getData('windows'),
      showFilter: '',
      windowSize: 'desktop',
    }
  },
  // Computed
  computed: {
    // These are used for setting values
    ...mapState({
      brands: state => state.filters.brands,
      colors: state => state.filters.colors,
      models: state => state.filters.models,
      surfaces: state => state.filters.surfaces,
      safetyClassifications: state => state.filters.safetyClassifications,
      doors: state => state.filters.doors,
      windows: state => state.filters.windows,
    }),
  },
  // Methods
  methods: {
    getData: function (key) {
      /* So what we want to do here is
      get the query string which is made up of
      transformed data, "untransform" it and then set state */

      const searchString = utils.getSearchString()
      const queryStringParams = new URLSearchParams(searchString)

      // Get data from search string else set it to empty array
      const inputData =
        !queryStringParams.get(key) || queryStringParams.get(key).length < 1
          ? []
          : queryStringParams.get(key).split('>')

      const queryStringData = []
      const storeData = []

      for (let index = 0; index < inputData.length; index++) {
        let item = inputData[index]

        // Clean up
        if (item.startsWith(',')) {
          item = item.substring(1)
        }

        // Ignore empty entry, then push to respective array
        if (item || !item.length === 0) {
          storeData.push(item)

          const queryStringItem = item + '>'
          queryStringData.push(queryStringItem)
        }
      }

      // Set initial data in store
      const payload = {
        type: key,
        value: storeData,
      }
      this.$store.dispatch('filters/setFilter', payload)

      // Set initial data in state
      return queryStringData
    },
    setData: function (array, type, value) {
      /* Basically what happens here is we send
      normal value to vuex store (and then later as a api request),
      meanwhile a transformed version of the value is created and used in the query string */
      const payload = {
        type: type,
        value: [value],
      }

      const transformedValue = value + '>'

      if (!value || value.length < 1) {
        // Empty entire array
        array.splice(0, array.length)
        this.$store.dispatch('filters/clearFilter', payload)
      } else {
        if (array.includes(transformedValue)) {
          // Remove identical entry (transformedValue)
          array.splice(array.indexOf(transformedValue), 1)
          this.$store.dispatch('filters/removeFilter', payload)
        } else if (array.includes(value)) {
          // Remove identical entry (value)
          array.splice(array.indexOf(value), 1)
          this.$store.dispatch('filters/removeFilter', payload)
        } else {
          // Add entry
          array.push(transformedValue)
          this.$store.dispatch('filters/addFilter', payload)
        }
      }

      // Reset pagination
      bus.$emit('reset_pagination')
      // Update query string
      this.updateQueryString(array, type)
    },
    updateQueryString: function (selectedItemArray, key) {
      bus.$emit('query_string_update')

      const searchString = utils.getSearchString()
      const queryStringParams = new URLSearchParams(searchString)

      if (selectedItemArray.length > 0) {
        queryStringParams.set(key, selectedItemArray)
      } else {
        queryStringParams.delete(key)
      }

      const newURL =
        window.location.origin +
        window.location.pathname +
        '?' +
        queryStringParams.toString()
      window.history.pushState({path: newURL}, '', newURL)
    },
    clickOutside(event) {
      if (this.windowSize === 'desktop' && this.showFilter) {
        if (
          !event.target.matches('[data-filter-button]') &&
          !event.target.closest('.product-filter__section__content')
        ) {
          this.showFilter = ''
        }
      }
    },
    filterClick(title) {
      this.showFilter = this.showFilter === title ? '' : title
    },
    handleToggle(value) {
      switch (value) {
        case 'open':
          document.querySelector('html').classList.add('product-filter--active')
          break
        case 'close':
          document
            .querySelector('html')
            .classList.remove('product-filter--active')
          break
        default:
          document
            .querySelector('html')
            .classList.toggle('product-filter--active')
          break
      }
    },
    handleResize(windowSize) {
      // Close mobile nav
      if (windowSize.width >= 1200) {
        this.windowSize = 'desktop'
        document
          .querySelector('html')
          .classList.remove('product-filter--active')
      } else {
        this.windowSize = 'mobile'
      }
    },
  },
  // Life cycle
  created() {
    bus.$on('brand_filter', value => {
      this.setData(this.checkedBrands, 'brands', value)
    })
    bus.$on('color_filter', value => {
      this.setData(this.checkedColors, 'colors', value)
    })
    bus.$on('model_filter', value => {
      this.setData(this.checkedModels, 'models', value)
    })
    bus.$on('surface_filter', value => {
      this.setData(this.checkedSurfaces, 'surfaces', value)
    })
    bus.$on('safetyClassification_filter', value => {
      this.setData(
        this.checkedSafetyClassifications,
        'safetyClassifications',
        value
      )
    })
    bus.$on('door_filter', value => {
      this.setData(this.checkedDoors, 'doors', value)
    })
    bus.$on('window_filter', value => {
      this.setData(this.checkedWindows, 'windows', value)
    })
    bus.$on('clearFilters', () => {
      this.setData(this.checkedBrands, 'brands', [])
      this.setData(this.checkedColors, 'colors', [])
      this.setData(this.checkedModels, 'models', [])
      this.setData(this.checkedSurfaces, 'surfaces', [])
      this.setData(
        this.checkedSafetyClassifications,
        'safetyClassifications',
        []
      )
      this.setData(this.checkedDoors, 'doors', [])
      this.setData(this.checkedWindows, 'windows', [])
      this.showFilter = ''
    })
    bus.$on('product_filter_toggle', () => {
      this.handleToggle('toggle')
    })
    bus.$on('window_resize', windowSize => {
      this.handleResize(windowSize)
    })

    document.addEventListener('click', this.clickOutside)
  },

  destroyed() {
    document.removeEventListener('click', this.clickOutside)
  },
}

export default ProductFilter
